import { ExhaustiveError } from "./exhaustiveerror";

export interface IBetweenOptions {
    /**
     * 下限値を閉区間とするかどうか (デフォルト:true)
     */
    includeLower?: boolean;

    /**
     * 上限値を閉区間とするかどうか (デフォルト:true)
     */
    includeUpper?: boolean;

    /**
     * 逆転した上限値と下限値を与えられた場合にどうするか
     *
     * * error
     *   * エラーとする
     * * false
     *   * falseを返す
     */
    handleInvalidRange?: "error" | "false";
}

/**
 * 指定された値が指定の範囲内にいるかどうかを返す。
 *
 * @param min 下限値
 * @param value 調べる値
 * @param max 上限値
 * @param options オプション
 * @returns 範囲内かどうか
 */
export const between = (
    min: number,
    value: number,
    max: number,
    options?: IBetweenOptions) => {

    // デフォルト値設定
    const {
        includeLower = true,
        includeUpper = true,
        handleInvalidRange = "false",
    } = options ?? {};

    // min > max のときの処理
    if (min > max) {
        switch (handleInvalidRange) {
            case "error": {
                throw new Error(`Invalid range: min (${min}) is greater than max (${max})`);
            }

            case "false": {
                return false;
            }

            default: {
                throw new ExhaustiveError(handleInvalidRange);
            }
        }
    }

    // 通常の範囲チェック
    const aboveMin = (includeLower) ? value >= min : value > min;
    const belowMax = (includeUpper) ? value <= max : value < max;

    return aboveMin && belowMax;
};
